import { Components } from "@thisgorilla/primate-ds";
import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
import { useImageContentContext } from ".";
import { FlexRowEnd } from "../../../../../../Common/Styles";
import { ImageContentProps } from "./imageContent";

export const PostCarousel = ({
  onNextClick,
  onPrevClick,
}: ImageContentProps.Carousel) => {
  const { carouselIndex, Images } = useImageContentContext();

  const isShowingBothButtons =
    carouselIndex > 0 && carouselIndex < Images.length - 1;

  return (
    <CarouselContainer
      $gapInPx={4}
      $isShowingBothButtons={isShowingBothButtons}
    >
      {carouselIndex > 0 && (
        <AnimatePresence mode="wait">
          <motion.span
            initial={{ transform: "translateX(100%)" }}
            animate={{ transform: "translateX(0)" }}
            exit={{ transform: "translateX(100%)" }}
            transition={{ duration: 0.3 }}
          >
            <Components.IconButton
              disabled={false}
              iconType="ChevronLeft"
              kind="Floating"
              onClick={onPrevClick}
              size="XS"
            />
          </motion.span>
        </AnimatePresence>
      )}
      {carouselIndex < Images.length - 1 && (
        <AnimatePresence mode="wait">
          <motion.span
            initial={{ transform: "translateX(0)" }}
            animate={{ transform: "translateX(0)" }}
            exit={{ transform: "translateX(100%)" }}
            transition={{ duration: 0.3 }}
          >
            <Components.IconButton
              disabled={false}
              iconType="ChevronRight"
              kind="Floating"
              onClick={onNextClick}
              size="XS"
            />
          </motion.span>
        </AnimatePresence>
      )}
    </CarouselContainer>
  );
};

const CarouselContainer = styled(FlexRowEnd)<{
  $isShowingBothButtons: boolean;
}>(
  ({ theme, $isShowingBothButtons }) => `
  position: absolute;
  top: ${
    $isShowingBothButtons
      ? theme.spacing["spacing-2"].value
      : theme.spacing["spacing-1"].value
  }rem;
  right: ${theme.spacing["spacing-1"].value}rem;
  transition: top 0.3s ease-in-out;
`
);
